import { Col } from "react-bootstrap";
import { Github, BoxArrowUpRight } from "react-bootstrap-icons";

export const ProjectCard = ({ title, description, imgUrl, link, techStack }) => {
  return (
    <Col size={12} sm={6} md={4} className="mb-4">
      <div className="project-card">
        {/* Top image area with hover overlay */}
        <div className="proj-imgbx">
          <img className="proj-img" src={imgUrl} alt={title} />
          
          <div className="proj-hover-overlay">
            <div className="proj-links">
              {/* GitHub Link (assuming 'link' is GitHub or we just point to it) */}
              <a href={link} target="_blank" rel="noopener noreferrer" className="proj-btn">
                <Github size={22} />
              </a>
              {/* Live Demo Link */}
              <a href={link} target="_blank" rel="noopener noreferrer" className="proj-btn">
                <BoxArrowUpRight size={22} />
              </a>
            </div>
          </div>
        </div>

        {/* Content area below image */}
        <div className="proj-content">
          <h4 className="proj-title">{title}</h4>
          <p className="proj-desc">{description}</p>
          
          <div className="proj-tech">
            {Array.isArray(techStack) && techStack.map((tech, index) => (
              <span key={index} className="proj-tech-pill">
                {tech}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Col>
  );
};
